export default __webpack_public_path__ + "static/media/RecieveCashlessLetter.06d8dfb4.svg";